// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.wizard-chart-wrap[data-v-588b4289] {\n  position: relative;\n  width: 100%;\n}\n.wizard-chart-wrap canvas[data-v-588b4289] {\n  width: 100% !important;\n}\n", ""]);
// Exports
module.exports = exports;
